import proTbs from '../pro_tb/list';
export default {
    components: { proTbs },
    data() {
        return {
            show_gg: false,
            admins: [],
            item_pro: {},
            show_tb: false,
            dls: [],
            table: 'pro',
            datas: {
                add: {
                    append: ['admin', 'js_admin', 'dl_admin'],
                    with_count: ['tbs']
                }
            },
            admin: {},
            r: {
                dl_name: '',
                call: '',
                dw: '',
                name: '',
                call: ''
            },
            is_html: false
        };
    },
    computed: {
        disabled() {
            if (!this.r.id) {
                return false;
            }
            if (this.vuex_admin.admin_group_id == 1) {
                return false;
            }
            if (this.r.admin_id == this.vuex_admin.id) {
                return false;
            }
            return true;
        }
    },
    created() {
        this._load();
        this._dls();
        this._admin();
        this._admins([2, 3]);
    },
    methods: {
        _gg(item) {
            this.item_pro = { ...item };
            this.show_gg = true;
        },
        _down_excels(id, code) {
            this.$http.post('pro/excels', {
                id,
                code
            }, {
                responseType: 'blob',
            }).then(res => {
                if (this.is_html) {
                } else {
                    const file = new Blob([res], { type: 'application/xlsx' });
                    // 创建一个指向Blob的URL
                    const fileURL = URL.createObjectURL(file);
                    // 创建一个临时的a标签用于下载
                    const fileLink = document.createElement('a');
                    fileLink.href = fileURL;
                    fileLink.setAttribute('download', 'download.xlsx'); // 设定下载文件名
                    document.body.appendChild(fileLink);
                    // 模拟点击a标签以触发下载
                    fileLink.click();
                    // 清理
                    document.body.removeChild(fileLink);
                    URL.revokeObjectURL(fileURL); // 释放内存中的URL对象
                }
            })
        },
        _down_excel(id) {
            this.$http.post('pro/excel', {
                id,
            }, {
                responseType: 'blob',
            }).then(res => {
                if (this.is_html) {
                } else {
                    const file = new Blob([res], { type: 'application/xlsx' });
                    // 创建一个指向Blob的URL
                    const fileURL = URL.createObjectURL(file);
                    // 创建一个临时的a标签用于下载
                    const fileLink = document.createElement('a');
                    fileLink.href = fileURL;
                    fileLink.setAttribute('download', 'download.xlsx'); // 设定下载文件名
                    document.body.appendChild(fileLink);
                    // 模拟点击a标签以触发下载
                    fileLink.click();
                    // 清理
                    document.body.removeChild(fileLink);
                    URL.revokeObjectURL(fileURL); // 释放内存中的URL对象
                }
            })
        },
        _set_js(id) {
            this.$http.post('admin/show', {
                id
            }).then(res => {
                if (res.code) {
                    this.r.name = res.data.name;
                    this.r.call = res.data.call;
                }
            })
        },
        _set_dl(id) {
            this.$http.post('admin/show', {
                id
            }).then(res => {
                if (res.code) {
                    this.r.dl_name = res.data.name;
                    this.r.dl_call = res.data.call;
                }
            })
        },
        _save(id = 0) {
            if (id) {
                this.$http.post('pro/show', {
                    id
                }).then(res => {
                    if (res.code) {
                        this.r = res.data;
                        this.show_save = true;
                    }
                })
            } else {
                this._reset('r');
                if (this.admin.admin_group_id == 3) {
                    this.r.dw = this.admin.admin_name;
                    this.r.name = this.admin.name;
                    this.r.call = this.admin.call;
                }
                this.show_save = true;
            }
        },
        _tb(item) {
            this.show_tb = true;
            this.item_pro = { ...item };
        },
        _down_pdf(item) {
            this.$http.post('pro/excel', {
                id: item.id,
            }, {
                // responseType: 'blob',
            }).then(res => {
                return;
                const file = new Blob([res], { type: 'application/xlsx' });
                // 创建一个指向Blob的URL
                const fileURL = URL.createObjectURL(file);
                // 创建一个临时的a标签用于下载
                const fileLink = document.createElement('a');
                fileLink.href = fileURL;
                fileLink.setAttribute('download', 'download.xlsx'); // 设定下载文件名
                document.body.appendChild(fileLink);
                // 模拟点击a标签以触发下载
                fileLink.click();
                // 清理
                document.body.removeChild(fileLink);
                URL.revokeObjectURL(fileURL); // 释放内存中的URL对象
            })
        },
        _dls() {
            this.$http.post('admin/list', {
                admin_group_id: 4
            }).then(res => {
                if (res.code) {
                    this.dls = res.data.data;
                }
            })
        },
    },
};